import { Component, input } from '@angular/core';

import { CmsTarget } from '@fcom/core-api';

@Component({
  selector: 'fin-cta-with-image-and-text',
  styleUrls: ['./cta-with-image-and-text.component.scss'],
  templateUrl: './cta-with-image-and-text.component.html',
  standalone: false,
})
export class CtaWithImageAndTextComponent {
  teaserTitle = input<string>();
  target = input<CmsTarget>();
  teaserText = input<string>();
  iconUrl = input<string>();
}
